import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import { transformMessageText } from '../../utils/utils';
import PriorMessage from '../PriorMessage/PriorMessage';

const MessageBody = message => {
  const { content, messageId, previousContent } = message;
  return (
    <Fragment>
      <div
        className="message-body"
        dangerouslySetInnerHTML={{
          __html: transformMessageText({ content, messageId })
        }}
      />
      {previousContent &&
        previousContent.length > 0 &&
        previousContent.map((prevMessage, i) => (
          <PriorMessage
            content={prevMessage}
            key={i}
            messageId={messageId}
            showPriorMessageLabel={i === 0}
          />
        ))}
    </Fragment>
  );
};

MessageBody.propTypes = {
  content: PropTypes.string,
  messageId: PropTypes.string,
  previousContent: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};

export default MessageBody;
